var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"u-p-30 bg_FFFFFF u-b-r-8 u-m-t-40 u-m-b-100"},[_c('div',{staticClass:"u-font-14 cl_333 u-l-h-30",domProps:{"innerHTML":_vm._s(_vm.info.value)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }